import { render } from "./CondoleancesView.vue?vue&type=template&id=64ce9bac"
import script from "./CondoleancesView.vue?vue&type=script&lang=js"
export * from "./CondoleancesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__